import users from "../services/UserService";

export interface ValidateEmailResult {
  isValid: boolean;
  message?: string;
}

export const EMAIL_MODAL_MESSAGE_ERROR = 'No es posible continuar con la compra de la suscripción debido a que el email ya se encuentra asociado a otro Plan de Cartera.';
export const DUPLICATED_EMAIL_TITLE = 'No se puede continuar con la suscripción'

export const validateUserEmail = async (): Promise<ValidateEmailResult> => {
  try {
    const result = await users.validateUserEmail();

    if (result !== true) {
      return {
        isValid: false,
        message:
          "",
      };
    }

    return { isValid: true };
  } catch (error: any) {
    console.error("Error en validateUserEmail:", error);

    const message = error.response?.data?.message ||
      EMAIL_MODAL_MESSAGE_ERROR;

    return {
      isValid: false,
      message,
    };
  }
};
